import { useEffect } from 'react';
import styles from './panelDocking.module.scss';

export const RECURRING_PANEL_WIDTH = 528;
export const OVERLAY_PANELS_QUERY = '(max-width:960px)';

// The booking panel and its close button live outside these panels' subtree, so they are
// reached through a class parked on `body` for as long as a docked panel is open.
export const useDockedPanelStyles = (docked = true): { paper: string } => {
    useEffect(() => {
        if (!docked) {
            return;
        }

        document.body.classList.add(styles.docked);

        return () => {
            document.body.classList.remove(styles.docked);
        };
    }, [docked]);

    return { paper: styles.paper };
};
